import { z } from 'zod';
// State of the BackOps "Approve for craftsmen" CTA for one offer request.
export const offerRequestCraftsmenApprovalResponseSchema = z.object({
    // Whether approving for craftsmen applies to this offer request at all: the Zurich process only.
    // BackOps hides the CTA when this is false.
    isApprovalSupported: z.boolean(),
    // Whether matching has already been triggered, which makes the CTA a one-way action.
    isMatchingTriggered: z.boolean(),
});
